import AES from 'crypto-js/aes'
import enc from 'crypto-js/enc-utf8'

const SOCKET_ENCRYPTION_KEY = process.env.REACT_APP_SOCKET_ENCRYPTION_KEY

const FE_ENCRYPTION_KEY = process.env.REACT_APP_FE_ENCRYPTION_KEY

export const encryptCredentials = (data) => {
  try {
    return AES.encrypt(data, FE_ENCRYPTION_KEY).toString()
  } catch (error) {
    console.error('Encrypt Credentials Error - ', error, data)
    return null
  }
}

export const decryptCredentials = (data) => {
  try {
    return AES.decrypt(data, FE_ENCRYPTION_KEY).toString(enc)
  } catch (error) {
    console.error('Decrypt Credentials Error - ', error, data)
    return null
  }
}

export const encryptSocketData = (data) => {
  return AES.encrypt(JSON.stringify(data), SOCKET_ENCRYPTION_KEY).toString()
}

export const encryptSocketToken = (token) => {
  return AES.encrypt(token, SOCKET_ENCRYPTION_KEY).toString()
}

export const decryptSocketData = (data) => {
  return JSON.parse(AES.decrypt(data, SOCKET_ENCRYPTION_KEY).toString(enc))
}

export const setLoginToken = (token) =>
  window.localStorage.setItem('access-token', encryptCredentials(token))

export const setRefreshToken = (token) =>
  window.localStorage.setItem('refresh-token', encryptCredentials(token))

export const getLoginTokenForSocket = () => {
  if (getItem('access-token')) {
    return encryptSocketToken(getItem('access-token'))
  }
  return ''
}

export const getLoginToken = () => {
  if (getItem('access-token')) {
    return getItem('access-token')
  }
  return ''
}

export const getRefreshToken = () => {
  if (window.localStorage.getItem('refresh-token')) return decryptCredentials(window.localStorage.getItem('refresh-token'))
  else return ''
}

export const removeLoginToken = () => {
  const languageCode = getItem('language')
  window.localStorage.clear()
  setItem('language', languageCode?.toUpperCase())
}

export const setItem = (key, value, encryptData = true) => {
  encryptData ? window.localStorage.setItem(key, encryptCredentials(value)) : window.localStorage.setItem(key, value)
}

export const getItem = (key) => {
  if (!window?.localStorage?.getItem(key)) {
    return window.localStorage.getItem(key)
  }
  if (key === 'userId') {
    return parseInt(decryptCredentials(window.localStorage.getItem(key)))
  }
  if (key === 'loggedIn') {
    return Boolean(decryptCredentials(window.localStorage.getItem(key)))
  }

  if (key === 'sessionExpiry') {
    return window.localStorage.getItem('sessionExpiry')
  }

  return decryptCredentials(window.localStorage.getItem(key))
}

export const removeItem = (key) => {
  if (window?.localStorage?.getItem(key)) {
    window.localStorage.removeItem(key)
  }
}

export const getCookie = (name = 'refToken') => {
  let value = ''
  const cookie = document.cookie
  const parts = cookie.split('; ')
  for (const i in parts) {
    if (value) return value
    if (parts[i]?.match(name)) {
      value = parts[i]?.split(`${name}=`)?.[1]
    }
  }
  return value
}

export const setCookie = (cname, cvalue, exdays) => {
  const d = new Date()
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
  const expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

export const deleteCookie = (cname) => {
  const d = new Date()
  d.setTime(d.getTime() + (24 * 60 * 60 * 1000))
  const expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=;' + expires + ';path=/'
}

export const getDocumentCookie = (cname) => {
  const name = cname + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

/**
 * Sets a cookie with the specified name, value and expiration days
 *
 * @param {string} name - The name of the cookie
 * @param {string|number} value - The value to store in the cookie
 * @param {number} [days] - Optional number of days until the cookie expires
 * @returns {void}
 */
export const setUniboCookie = (name, value, days) => {
  if (value === undefined || value === null) return
  let expires = ''
  if (typeof days === 'number') {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }
  document.cookie = `${name}=${encodeURIComponent(String(value))}${expires}; path=/; SameSite=Lax`
}
